/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {getLatestPCRDate} from "../../../api/sensorApi";
import { toast } from "react-toastify";

const useLatestPCRDate = (sensorID) => {
    const [latestPCRDate, setLatestPCRDate] = useState(null);

    const fetchLatestPCRDate = () => {
        getLatestPCRDate({ sensor_id: sensorID }).then((data) => {
            setLatestPCRDate(data);
        }).catch((err) => {
            console.error(err);
            toast.error("Cannot fetch latest prediction date! ")
        });
    };

    useEffect(() => {
        if (sensorID) {
            fetchLatestPCRDate();
        }
    }, [sensorID]);

    return { latestPCRDate, fetchLatestPCRDate };
};


export default useLatestPCRDate;